import { render, staticRenderFns } from "./aladin-chart.vue?vue&type=template&id=b69d364c"
import script from "./aladin-chart.vue?vue&type=script&lang=js"
export * from "./aladin-chart.vue?vue&type=script&lang=js"
import style0 from "./aladin-chart.vue?vue&type=style&index=0&id=b69d364c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports